import {LoginRecoveryContainer} from '../containers/LoginRecoveryContainer/index'

export const LoginRecoveryPage = () => {

    return (
        <>
            <LoginRecoveryContainer />
        </>
    )
}